<section class="users-view">
  <!-- Media object starts -->
  <div class="row">
    <div class="col-12 col-sm-7">
      <div class="media d-flex align-items-center">
        <a href="javascript:;">
          <img *ngIf="!employeeData?.image" src="assets/MeanderLIVE-icon.png" alt="user view avatar"
            class="users-avatar-shadow rounded" height="64" width="64" />
          <img *ngIf="employeeData?.image" [src]="imageUrl + employeeData?.image" alt="user view avatar"
            class="users-avatar-shadow rounded" height="64" width="64" />
        </a>
        <div class="media-body ml-3">
          <h4>
            <span class="users-view-name mr-1">{{
              employeeData?.name
              }}</span>
            <!-- <span class="text-muted font-medium-1">
                    <span>@</span>
                    <span class="users-view-username">dean3004</span>
                  </span> -->
          </h4>
          <span class="mr-1">ID :</span>
          <span class="users-view-id">{{
            employeeData?._id.substring(employeeData?._id.length - 6)
            }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
      <!-- <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          ><i class="ft-mail"></i
        ></a>
        <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          >Profile</a
        > -->
      <a [routerLink]="['/employees/edit', employeeData?._id]" class="btn btn-sm btn-primary px-3 py-1">Edit</a>
    </div>
  </div>
  <!-- Media object ends -->

  <div class="row">
    <div class="col-12">
      <!-- Card data starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-xl-4">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>Business Name :</td>
                      <td>{{ employeeData?.name }}</td>
                    </tr>

                    <tr>
                      <td>Registered :</td>
                      <td>
                        {{ employeeData?.created_at | date: "mediumDate" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Latest Activity :</td>
                      <td class="users-view-latest-activity">
                        {{ employeeData?.updated_at | date: "mediumDate" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Verified :</td>
                      <td class="users-view-verified">Yes</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Card data ends -->
    </div>
    <div class="col-12">
      <!-- User detail starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <i class="ft-info mr-2"></i> Business Info
              </h5>
              <div class="table-responsive">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>LinkedIn :</td>
                      <td>{{ employeeData?.linkedIn }}</td>
                    </tr>
                    <tr>
                      <td>Email :</td>
                      <td>{{ employeeData?.email }}</td>
                    </tr>
                    <tr>
                      <td>Notes :</td>
                      <td>{{ employeeData?.notes }}</td>
                    </tr>
                    <tr>
                      <td>Contact :</td>
                      <td>{{ employeeData?.phone }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- User detail ends -->
  </div>
</section>